import { LEFT_CARD, SKELETON_LOADER_STYLE, TABLE_CARD } from './constants';
import { GridSkeletonLoader } from './GridSkeletonLoader';
import { SkeletonFooter } from './SkeletonFooter';
import { SkeletonLoader } from './SkeletonLoader';
import { StyledColumn, StyledDiv, StyledGrid, StyledRow } from './styled';
import { LoaderStyle } from './types';
import type { FC } from 'react';

export const SkeletonPageLayout: FC = () => (
  <>
    <StyledGrid data-testid="grid">
      <StyledRow>
        <StyledColumn>
          <StyledDiv variant={LEFT_CARD}>
            <SkeletonLoader
              height={LoaderStyle.height24}
              width={LoaderStyle.width}
            />
          </StyledDiv>
        </StyledColumn>
      </StyledRow>
      <StyledRow>
        {[...Array(4)].map(value => (
          <SkeletonLoader
            key={value}
            height={LoaderStyle.height24}
            width={LoaderStyle.width129}
            style={SKELETON_LOADER_STYLE}
          />
        ))}
      </StyledRow>
      <StyledColumn>
        <StyledDiv variant={TABLE_CARD}>
          <GridSkeletonLoader rows={15} columns={9} />
        </StyledDiv>
      </StyledColumn>
    </StyledGrid>
    <SkeletonFooter />
  </>
);
